/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useEffect, useRef } from 'react'
// import { KTIcon } from '../../../../helpers'
import { KTIcon } from '../../../helpers'
// import { getCSSVariableValue } from '../../../../assets/ts/_utils'
import { getCSSVariableValue } from '../../../assets/ts/_utils'
// import { useThemeMode } from '../../../layout/theme-mode/ThemeModeProvider'
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

type Props = {
  className?: string
  chartSize?: number
  chartLine?: number
  chartRotate?: number
  lifetimeCollection?: number
  recyclable?: number
  nonRecyclable?: number
}

const CardsWidget17: FC<Props> = ({
  className,
  chartSize = 70,
  chartLine = 11,
  chartRotate = 145,
  lifetimeCollection = 0,
  recyclable = 0,
  nonRecyclable = 0,
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  useEffect(() => {
    refreshChart()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode])

  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    setTimeout(() => {
      initChart(chartSize, chartLine, chartRotate)
    }, 10)
  }

  return (
    <div className={`card card-flush ${className}`}>
      <div className='card-header pt-5'>
        <div className='card-title d-flex flex-column'>
          <div className='d-flex align-items-center'>
            {/* <span className='fs-4 fw-semibold text-gray-400 me-1 align-self-start'>$</span> */}

            <span className='fs-2hx fw-bold text-dark me-2 lh-1 ls-n2'>{lifetimeCollection?.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} kg</span>

            {/* <span className='badge badge-light-success fs-base'>
              <KTIcon iconName='arrow-up' className='fs-5 text-success ms-n1' /> 2.2%
            </span> */}
          </div>
          <span className='text-dark-400 pt-1 fw-semibold fs-6'>Lifetime collection</span>
        </div>
      </div>

      <div className='card-body pt-2 pb-4 d-flex flex-wrap align-items-center justify-content-center'>


        {/* <div className='d-flex flex-column content-justify-center flex-row-fluid'>
          <div className='d-flex fw-semibold align-items-center'>
            <div className='bullet w-8px h-3px rounded-2 bg-success me-3'></div>
            <div className='text-gray-500 flex-grow-1 me-4'>Recycable</div>
            <div className='fw-bolder text-gray-700 text-xxl-end'>{recyclable}</div>
          </div>
          <div className='d-flex fw-semibold align-items-center my-3'>
            <div className='bullet w-8px h-3px rounded-2 bg-primary me-3'></div>
            <div className='text-gray-500 flex-grow-1 me-4'>Non Recycable</div>
            <div className='fw-bolder text-gray-700 text-xxl-end'>{nonRecyclable}</div>
          </div>
        
        </div> */}
        <div className='d-flex flex-column align-items-center gap-4'>
          {/* Circle on Left - Even Smaller */}
          <div className='flex-shrink-0' style={{ width: '200px', height: '200px' }}>
            <svg viewBox="0 0 100 100" className="w-full h-full">
              {/* Blue - 29.34% */}
              <OverlayTrigger
                placement='top'
                overlay={<Tooltip id='tooltip-recyclable'>Recyclable: {recyclable} kg</Tooltip>}
              >
                <circle
                  cx="50"
                  cy="50"
                  r="38"
                  fill="none"
                  stroke="#ed6e43"
                  strokeWidth="18"
                  strokeDasharray={`${(recyclable / ((recyclable + nonRecyclable))) * 238.76} 238.76`}
                  strokeLinecap="round"
                  transform="rotate(-90 50 50)"
                  style={{ cursor: 'pointer' }}
                />
              </OverlayTrigger>

              {/* Green - 72.56% */}
              <OverlayTrigger
                placement='top'
                overlay={<Tooltip id='tooltip-non-recyclable'>Non recyclable: {nonRecyclable} kg</Tooltip>}
              >
                <circle
                  cx="50"
                  cy="50"
                  r="38"
                  fill="none"
                  stroke="#4f45f5"
                  strokeWidth="18"
                  strokeDasharray={`${(nonRecyclable / ((recyclable + nonRecyclable))) * 238.76} 238.76`}
                  strokeDashoffset={`${-((recyclable / ((recyclable + nonRecyclable))) * 238.76)}`}
                  strokeLinecap="round"
                  transform="rotate(-90 50 50)"
                  style={{ cursor: 'pointer' }}
                />
              </OverlayTrigger>

              {/* Gray - 17.83% */}
              {/* <OverlayTrigger
                placement='top'
                overlay={<Tooltip id='tooltip-remaining'>Remaining</Tooltip>}
              >
                <circle
                  cx="50"
                  cy="50"
                  r="38"
                  fill="none"
                  stroke="#e4e6ef"
                  strokeWidth="18"
                  strokeDasharray={`${(17.83 / 100) * 238.76} 238.76`}
                  strokeDashoffset={`${-((29.34 + 72.56) / 100) * 238.76}`}
                  strokeLinecap="round"
                  transform="rotate(-90 50 50)"
                  style={{ cursor: 'pointer' }}
                />
              </OverlayTrigger> */}

              {/* Center white */}
              <circle cx="50" cy="50" r="20" fill="white" />
            </svg>
          </div>

          {/* Content on Right */}
          <div className='flex-grow-1'>
            <div className='d-flex fw-semibold align-items-center mb-3'>
              <div className='bullet w-8px h-3px rounded-2 me-3' style={{ backgroundColor: '#ed6e43' }}></div>
              <div className='text-dark-500 flex-grow-1 me-4'>Recyclable</div>
              <div className='fw-bolder text-gray-700'>{recyclable?.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
            </div>
            <div className='d-flex fw-semibold align-items-center'>
              <div className='bullet w-8px h-3px rounded-2 me-3' style={{ backgroundColor: '#4f45f5' }}></div>
              <div className='text-dark-500 flex-grow-1 me-4'>Non recyclable</div>
              <div className='fw-bolder text-gray-700'>{nonRecyclable?.toLocaleString('en', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const initChart = function (
  chartSize: number = 70,
  chartLine: number = 11,
  chartRotate: number = 145
) {
  const el = document.getElementById('kt_card_widget_17_chart')
  if (!el) {
    return
  }
  el.innerHTML = ''

  var options = {
    size: chartSize,
    lineWidth: chartLine,
    rotate: chartRotate,
    //percent:  el.getAttribute('data-kt-percent') ,
  }

  const canvas = document.createElement('canvas')
  const span = document.createElement('span')

  // @ts-ignore
  if (typeof G_vmlCanvasManager !== 'undefined') {
    // @ts-ignore
    G_vmlCanvasManager.initElement(canvas)
  }

  const ctx = canvas.getContext('2d')
  canvas.width = canvas.height = options.size

  el.appendChild(span)
  el.appendChild(canvas)

  // @ts-ignore
  ctx.translate(options.size / 2, options.size / 2) // change center
  // @ts-ignore
  ctx.rotate((-1 / 2 + options.rotate / 180) * Math.PI) // rotate -90 deg

  //imd = ctx.getImageData(0, 0, 240, 240);
  const radius = (options.size - options.lineWidth) / 2

  const drawCircle = function (color: string, lineWidth: number, percent: number) {
    percent = Math.min(Math.max(0, percent || 1), 1)
    if (!ctx) {
      return
    }

    ctx.beginPath()
    ctx.arc(0, 0, radius, 0, Math.PI * 2 * percent, false)
    ctx.strokeStyle = color
    ctx.lineCap = 'round' // butt, round or square
    ctx.lineWidth = lineWidth
    ctx.stroke()
  }

  // Init 2
  drawCircle('#E4E6EF', options.lineWidth, 100 / 100)
  drawCircle(getCSSVariableValue('--bs-primary'), options.lineWidth, 100 / 150)
  drawCircle(getCSSVariableValue('--bs-success'), options.lineWidth, 100 / 250)
}

export { CardsWidget17 }
